import household from './household'

export default {
  // 住戶、戶別
  ...household
}
